import { render, staticRenderFns } from "./ExtensibleSlideContent.vue?vue&type=template&id=59e45713&scoped=true"
import script from "./ExtensibleSlideContent.vue?vue&type=script&lang=js"
export * from "./ExtensibleSlideContent.vue?vue&type=script&lang=js"
import style0 from "./ExtensibleSlideContent.vue?vue&type=style&index=0&id=59e45713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e45713",
  null
  
)

export default component.exports